import { extendTheme, withDefaultSize } from '@chakra-ui/react';
import { Dict } from '@chakra-ui/utils';

import * as tokens from '../generated/variables';
import { components } from './components';
import './fonts';
import { styles } from './styles';
import { foundations } from '../generated/foundations';
import { semanticTokens } from '../generated/semantic';

export const chakraUiTheme: Dict = extendTheme(
  {
    /**
     * Note:
     * Spreading all tokens here into `everfi` namespace for any use in consumers
     * TODO: This will go away when design system will get fully transitioned to semantics
     */
    everfi: {
      ...tokens,
    },
    // foundations and semantics
    config: {
      cssVarPrefix: 'udl',
    },
    ...foundations,
    semanticTokens: {
      ...semanticTokens,
      space: semanticTokens.space.base,
    },

    components,
    styles,
    textStyles: semanticTokens.textStyles.base,
  },
  withDefaultSize({ size: 'md' })
);

export * from './hooks';
